import {v3} from "oc-threejs/short3";
import Brett from "../../object3d/Brett";
export default class Preisberechnung {

    currentSchrankIndex;
    currrentElementIndex;

    constructor(arrangement) {
        this.arrangement = arrangement;
        this.partsList = this.arrangement.partsList;
    }

    /**
     * @return {number}
     */
    getPreis(){
        return this._getPreisVonArrangement();
    }

    calcAssemblyPrice(priceType = 'customer') {
        let costs = 0;
        console.log('Montagekosten zz disabled')
        return costs;
    }

    /**
     * @return {number}
     * @private
     */
    _getPreisVonServer(){
        return 0;
    }

    /**
     * @return {{rabatt: number, gesamtPreis: number}}
     * @private
     */
    _getPreisVonArrangement(){

        this._updateLocalPartsList();
        let gesamtPreis = this._getPreisFromPartsList();
        const verpackung = APP.settings.fixPreis.Verpackungskosten;
        const materialZuschlag = APP.settings.fixPreis.MaterialkostenzuschlagProzent;
        const weitereFertigungskosten = APP.settings.fixPreis.WeitereFertigungskosten;
        const kommission = APP.settings.fixPreis.Kommissionierung;
        const verwaltung = APP.settings.fixPreis.VerwaltungskostenProzent;
        const rta = APP.settings.fixPreis.RTAProzent;

        console.log("GESAMTPREIS", gesamtPreis);
        gesamtPreis = (gesamtPreis + verpackung) * (1.0 + materialZuschlag/100);
        gesamtPreis += weitereFertigungskosten;
        gesamtPreis += kommission;
        gesamtPreis *= (1.0 + verwaltung/100);
        gesamtPreis *= (1.0 + rta/100);
        console.log("INSGESAMT ", gesamtPreis);
        let result = {
            gesamtPreis: gesamtPreis,
            rabatt: 0
        }
        const hasRabatt = APP.haendler?.Faktor;
        if (hasRabatt) {
            result.rabatt = result.gesamtPreis * parseInt(APP.haendler.Faktor) / 100;
        }
        return result;
    }

    /**
     * @return {number}
     * @private
     */
    _getPreisFromPartsList(){
        let preis = 0;
        // preis += this.partsList.model.preis;
        this.partsList.schraenke.forEach(schrank => {
            preis += schrank.modellPreis.preis;
            schrank.parts.forEach(schrankPart => {
                if (schrankPart.preis) {
                    preis += schrankPart.preis;
                }
                if (schrankPart.parts) {
                    schrankPart.parts.forEach(internalPart => {
                        if (internalPart.preis) {
                            preis += internalPart.preis;
                        }
                    });
                }
            })
        });
        return preis / 100;
    }

    _updateLocalPartsList() {
        this.partsList.schraenke.length = 0;
        this.arrangement.schraenke.forEach((schrank, index) => {
            this.currentSchrankIndex = index;
            this.partsList.schraenke.push(this._calculateLocalSchrankPreis(schrank));
        });

    }

    _createPartsListEntry(item, priceData, product = null) {
        //materialInfo: {Artikelnummer: userData.material, Name:dekor.Name, qmPreis: dekor.qmPreis},

        const usedProduct = product ? product : item.product;
        const entry = {
            groesse: this._getConfigSize(item),
            priceData: priceData,
            preis: priceData.preis,
            schrankIndex: this.currentSchrankIndex,
            elementIndex: this.currrentElementIndex
        };
        ['Name', 'Anzeigereihenfolge', 'Anzeigename', 'Artikelnummer', 'Beschreibung', 'type'].forEach(key => {
            entry[key] = usedProduct[key];
        });
        //console.log(item.product.Artikelnummer, item.mainAxes);
        if (item.materialArtikelnummer) {
            const materialData = APP.findProduct(item.materialArtikelnummer);
            entry.materialInfo = {
                Artikelnummer: item.materialArtikelnummer,
                Name: materialData.Name,
                /* qmGewicht: materialData.qmGewicht,
                qmPreis: materialData.qmPreis */
            };
        }
        // console.log(item.type || item.product.Artikelnummer, priceData);
        return entry;
    }

    _createGriffEntry(griff, griffArtikelnummer) {
        //console.log(griff, griffArtikelnummer);
        let product = griff.product || APP.findProduct(griff.schrank.griffArtikelnummer);
        // if (griffArtikelnummer) {
        //     product = APP.findProduct(griffArtikelnummer);
        // }
        // griff.product = product ?? griff.product;
        if(product === undefined) {
            console.error("product ", griff.schrank.griffArtikelnummer, " missing in database");
            throw new Error("Griff '" + griff.schrank.griffArtikelnummer + "' nicht gefunden");
        }
        return this._createPartsListEntry(griff, this._getProduktPreis(product, griff), product);
    }

    _calculateLocalSchrankPreis(schrank) {
        let result = {
            parts: []
        };
        const drillteqZuschlagSeiten = APP.settings.fixPreis.DrillteqSeiten;
        const drillteqZuschlagBoeden = APP.settings.fixPreis.DrillteqBoeden;
        const drillteqZuschlagKonstruktionsboden = APP.settings.fixPreis.DrillteqKonstruktionsboden;
        const drillteqZuschlagTuer = APP.settings.fixPreis.DrillteqTuer;
        const brettZuschlag = APP.settings.fixPreis.Bretter;
        const schrankIndex = this.arrangement.schraenke.indexOf(schrank);

        const addInterieurPart = (interieur => {
            if (interieur.product.type === 'Schubladenbox') {
                interieur.drawers?.forEach(drawer => {
                    einbautenObject.parts.push(this._createPartsListEntry(interieur, {preis:  interieur.getPrice()}));
                    if (drawer.griff) {
                        if (drawer.griff.artikelnummer === 'PushToOpen') {
                            griffeObject.parts.push(this._createGriffEntry(drawer.griff, 'PushToOpen-Schublade'));
                        } else {
                            griffeObject.parts.push(this._createGriffEntry(drawer.griff));
                        }
                    }
                });
            } else if (interieur.product.type === 'Tuer') {
                tuerenObject.parts.push(this._createPartsListEntry(interieur, {preis: interieur.getPrice() + drillteqZuschlagTuer + brettZuschlag}));
                interieur.fluegel.filter(fluegel => fluegel.griff).forEach(fluegel => griffeObject.parts.push(this._createGriffEntry(fluegel.griff, fluegel.griff.griffArtikelnummer)))
            } else if (interieur.product.type === 'Kleiderstange') {
                const kleiderstangeProduct = APP.findProduct('Kleiderstange');
                const kleiderstangeEntry = this._createPartsListEntry(interieur, this._getProduktPreis(kleiderstangeProduct, interieur), kleiderstangeProduct);
                einbautenObject.parts.push(kleiderstangeEntry);
            } else if (interieur.product.type === 'Konstruktionsboden') {
                einbautenObject.parts.push(this._createPartsListEntry(interieur, {preis: interieur.brett.getPrice() + drillteqZuschlagKonstruktionsboden + brettZuschlag}) );
            } else if (interieur.product.type === 'Einlegeboden') {
                einbautenObject.parts.push(this._createPartsListEntry(interieur, {preis: interieur.brett.getPrice() + brettZuschlag}) );
            } else if (interieur.product.type === 'Trennwandbox') {
                einbautenObject.parts.push(this._createPartsListEntry(interieur, {preis: interieur.getPrice()}) );
            } else {
                einbautenObject.parts.push(this._createPartsListEntry(interieur, this._getProduktPreis(interieur.product, interieur)));
            }
        });

        const aussenwaende = {
            name: 'Aussenwände',
            parts: []
        };
        const tuerenObject = {
            name: 'Türen',
            parts: []
        };
        const griffeObject = {
            name: 'Griffe',
            parts: []
        };
        const einbautenObject = {
            name: 'Einbauten',
            parts: []
        };
        const verbundTeile = {
            name: 'Verbundteile',
            parts: []
        };
        _.forEach(schrank.outerWalls, aussenwand => {
            aussenwaende.parts.push(this._createPartsListEntry(aussenwand, {preis: aussenwand.getPrice() + drillteqZuschlagSeiten + brettZuschlag}) );
        });

        if(schrank.rueckwand?.exists) {
            aussenwaende.parts.push(this._createPartsListEntry(schrank.rueckwand, this._getProduktPreis(schrank.rueckwand.product, schrank.rueckwand)));
        }

        if(schrank.deckel.exists) {
            aussenwaende.parts.push(this._createPartsListEntry(schrank.deckel, {preis: schrank.deckel.getPrice() + drillteqZuschlagBoeden + brettZuschlag}));
        }

        if(schrank.schrankboden) {
            aussenwaende.parts.push(this._createPartsListEntry(schrank.schrankboden, {preis: schrank.schrankboden.getPrice() + drillteqZuschlagBoeden + brettZuschlag}));
        }

        schrank.elements.forEach((element, elementIndex) => {
            this.currrentElementIndex = elementIndex;
            element.interieurs.forEach((interieur) => {
                addInterieurPart(interieur);

                interieur.elements?.forEach(internalElement => {
                    internalElement.interieurs?.forEach( internalInterieur => {
                        addInterieurPart(internalInterieur);
                    });
                });
            });
            
            element.konstruktionsboeden.forEach((boden) => {
                //console.log('Preisberechnung Boden:', boden);
                einbautenObject.parts.push(this._createPartsListEntry(boden, this._getProduktPreis(boden.product, boden)));
            });
        });

        _.forEach(schrank.sockel?.sockelBretter, (sockelbrett) => {
            if(sockelbrett) {
                aussenwaende.parts.push(this._createPartsListEntry(sockelbrett, {preis: sockelbrett.getPrice() + brettZuschlag}));
            }
        });

        if (schrank.isSchwebetuer) {
            const schiene = schrank.schwebetuer.schienen[0];
            const schieneProduct = APP.findProduct('SchwebeTuerLaufschiene');
            const schieneEntry = this._createPartsListEntry(schiene, this._getProduktPreis(schieneProduct, schiene), schieneProduct);
            tuerenObject.parts.push(schieneEntry);

            schrank.schwebetuer.schwebetuerFluegel.forEach((fluegel) => {
                fluegel.fronten.forEach((front, index) => {
                    let tuerEntry;
                    if (index % 2 === 0) {
                        tuerEntry = this._createPartsListEntry(front, this._getProduktPreis(front.product, front));
                    } else {
                        const frontProductArtikelnummer = 'SchwebetuerDekor' + (_.upperFirst(fluegel.streifen) === 'Dekor' ? 'Standard' : _.upperFirst(fluegel.streifen));
                        const frontProduct = APP.findProduct(frontProductArtikelnummer);
                        tuerEntry = this._createPartsListEntry(front, this._getProduktPreis(frontProduct, front));
                    }
                    tuerenObject.parts.push(tuerEntry);
                });
            });
        }
        if (schrank.needsPassleiste) {
            const passleisteProduct = APP.findProductsByType('Passleiste')[0];
            if (passleisteProduct) {
                const laengen = schrank.passleisteLaenge ?? [];
                laengen.forEach(laenge => {
                    const dummyVsConfig = {
                        product: passleisteProduct,
                        size: v3(laenge, laenge, laenge),
                        parent: schrank
                    };
                    const p = this._getProduktPreis(passleisteProduct, dummyVsConfig);
                    p.preisDimensionen = [p.preisDimensionen.find(x => x.faktor > 0)];
                    p.preisDimensionen[0].name = "Länge";

                    const passleisteEntry = this._createPartsListEntry(passleisteProduct, p, passleisteProduct);
                    verbundTeile.parts.push(passleisteEntry);
                });
            }
        }

        result.parts.push(_.cloneDeep(aussenwaende));
        result.parts.push(_.cloneDeep(einbautenObject));
        result.parts.push(_.cloneDeep(tuerenObject));
        result.parts.push(_.cloneDeep(griffeObject));
        result.parts.push(_.cloneDeep(verbundTeile));
        result.modellPreis = this.calculateLocalModelPrice(schrank);
        return result;
    }

    calculateLocalModelPrice(schrank) {        
        const model = schrank.modell;
        const negativePricingPossible = schrank.options.getBool("negative_pricing_possible");
        const dims = this._getModelDimensions(model);
        const prod = {
            Dekortyp: 'corpus'
        };
        const priceData = {
            preisDimensionen: dims,
            standard: Preisberechnung.priceToCents(model.PreisStandard),
            materialFaktor: this._getMaterialFactor(prod, APP.getMaterialForVsData(this.arrangement.schraenke[this.currentSchrankIndex]))
        };
        this._calculatePriceData(priceData, negativePricingPossible, schrank.withRueckwand, schrank.withDeckel, schrank.modell.OhneRueckwandPreisnachlass, schrank.modell.OhneOberbodenPreisnachlass);
        return priceData;
    }

    /**
     *
     * @param product
     * @param config
     * @return {{standard: number, preisDimensionen: [], materialFaktor: number}}
     * @private
     */
    _getProduktPreis(product, config){
        if (product == null) {
            return {
                preisDimensionen: [],
                standard: 0,
                materialFaktor: 0
            };
        }
        const priceData = {
            preisDimensionen: this._getProductDimensions(product, this._getConfigSize(config)),
            standard: Preisberechnung.priceToCents(product.PreisStandard),
            materialFaktor: this._getMaterialFactor(product, config.materialArtikelnummer || APP.getMaterialForVsData(config))
        };
        this._calculatePriceData(priceData);
        return priceData;
    }

    _getConfigSize(config) {
        return v3(config.flaecheMass || config.size || null);
    }

    _getProductDimensions(product, size) {
        const dims = [];
        [["Hoehe", "y"], ["Tiefe", "z"], ["Breite", "x"]].forEach(dim => {
            dims.push({
                name: dim[0],
                ist: size[dim[1]],
                standard: product[dim[0] + 'Standard'],
                faktor: Preisberechnung.priceToCents(product[dim[0] + 'Faktor']),
            })
        });
        return dims;
    }

    _getModelDimensions(model) {
        const dims = this._getProductDimensions(model, this._getConfigSize(this.arrangement.schraenke[this.currentSchrankIndex]));
        dims.push({
            name: "Kniestock",
            standard: model['KniestockStandard'],
            faktor: Preisberechnung.priceToCents(model['KniestockFaktor']),
            ist: this.arrangement.schraenke[this.currentSchrankIndex].sizeTop.y
        });
        dims.push({
            name: "BreiteOben",
            standard: model['BreiteObenStandard'],
            faktor: Preisberechnung.priceToCents(model['BreiteObenFaktor']),
            ist: this.arrangement.schraenke[this.currentSchrankIndex].sizeTop.x
        });
        dims.push({
            name: "AnzahlElemente",
            standard: model['AnzahlElementeStandard'],
            faktor: Preisberechnung.priceToCents(model['AnzahlElementeFaktor']),
            ist: this.arrangement.schraenke[this.currentSchrankIndex].elements.length
        });
        dims.push({
            name: "AnzahlSchraegeElemente",
            standard: model['AnzahlSchraegeElementeStandard'],
            faktor: Preisberechnung.priceToCents(model['AnzahlSchraegeElementeFaktor']),
            ist: this.arrangement.schraenke[this.currentSchrankIndex].elements.filter(e => e.isSchraeg()).length
        });
        return dims;
    }

    _getMaterialFactor(product, materialArtikelnummer) {
        let prozent = 0;
        const material = APP.findProduct(materialArtikelnummer);

        if (product.Dekortyp != 'ohne' && material) {
            prozent = material.Faktor;
        }
        /* console.log(prozent); */
        return 1.0 + prozent / 100.0;
    }

    _calculatePriceData(data, negativePricingPossible = false, rueckwand = true, deckel = true, nachlassRueckwand = 0, nachlassDeckel = 0) {
        let preis = data.standard;
        /* alte Preisberechnung
        data.preisDimensionen.reduce((preis, dim) => {
            let dimDiff = dim.ist - dim.standard;
            if (!negativePricingPossible && dimDiff < 0) {
                dimDiff = 0;
            }
            // damit der Preis entsprechend des eingesparten Materials kleiner wird eigentlich so:
            // if(dim.name === "Breite" && !rueckwand) preis-=dim.ist*dim.faktor*2/3;
            // if(dim.name === "Tiefe" && !rueckwand) preis-=dim.ist*dim.faktor*1/4;
            return (preis + dimDiff * dim.faktor)

        }, data.standard);
        */
        if(rueckwand) nachlassRueckwand = 0;
        if(deckel) nachlassDeckel = 0;
        preis = preis * (1-nachlassRueckwand-nachlassDeckel);
        if (preis < 0) preis = 0;
        data.preis = Math.round(data.materialFaktor * preis);
    }

    /**
     * @param schrank
     * @return {[]}
     */
    getVerbundArtikel(schrank){
        const verbundArtikel = [
            schrank.schrankboden,
        ];
        if (schrank.sockel) {
            verbundArtikel.push(schrank.sockel);
        }
        if (!schrank.deckel.needEinzelneDeckel) {
            verbundArtikel.push(schrank.deckel);
        }
        if (schrank.settings.getBool('rueckwand_ist_verbundartikel')) {
            verbundArtikel.push(schrank.rueckwand);
        }
        return verbundArtikel;
    }

    static priceToCents(price) {
        return price * 100;
    }

    static centsToPrice(cents) {
        return Helper.round(cents / 100);
    }

    static getSchrankPreis(schrank) {
        let price = _.get(schrank, 'preis', 0);
        schrank.parts.forEach(part => {
            price += _.get(part, 'preis', 0);
            if (part.parts) {
                part.parts.forEach(child => {
                    price += _.get(child, 'preis', 0);
                });
            }
        });
        return price;
    }
}
